class NotifyMeButtonWrapper extends HTMLElement {
    constructor() {
        super();
        this.container = this.querySelector('notify-container');
        this.button = this.querySelector('button');
        this.addToCartWrapper = this.closest('.buy-buttons-block') || this.closest('.product-form-buttons') || this.parentElement;

        if (this.addToCartWrapper) {
            this.addToCartButton = this.addToCartWrapper.querySelector('add-to-cart-component button') || this.addToCartWrapper.querySelector('button[name="add"]');
        }

        if (this.addToCartButton) {
            this.observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
                        this.updateVisibility();
                    }
                });
            });
            this.observer.observe(this.addToCartButton, { attributes: true });
        } else {
            // Fallback: listen to the document for variant changes if we can't observe the add-to-cart button directly.
            document.addEventListener('change', this.onVariantChangeFallback.bind(this));
        }

        this.button?.addEventListener('click', this.onClick.bind(this));

        // Initial check
        setTimeout(() => this.updateVisibility(), 100);
    }

    updateVisibility() {
        if (this.addToCartButton && this.addToCartButton.disabled) {
            const text = this.addToCartButton.textContent.toLowerCase();
            // "Sold out", "Épuisé", "Subscribe", or simply if it's disabled and we know it's a product variant.
            if (text.includes('sold out') || text.includes('sold_out') || text.includes('subscribe') || text.trim() === 'unavailable' || text.trim() === 'sold out') {
                this.container.classList.remove('hide');
                const component = this.addToCartButton.closest('add-to-cart-component');
                if (component) component.classList.add('hide');
                else this.addToCartButton.classList.add('hide');
            } else {
                this.container.classList.add('hide');
                const component = this.addToCartButton.closest('add-to-cart-component');
                if (component) component.classList.remove('hide');
                else this.addToCartButton.classList.remove('hide');
            }
        } else {
            this.container.classList.add('hide');
            if (this.addToCartButton) {
                const component = this.addToCartButton.closest('add-to-cart-component');
                if (component) component.classList.remove('hide');
                else this.addToCartButton.classList.remove('hide');
            }
        }

        // Sticky Mobile Button Intercept
        const stickyButtonContainer = this.closest('.shopify-section')?.querySelector('sticky-add-to-cart');
        if (stickyButtonContainer) {
            const stickyButtonNode = stickyButtonContainer.querySelector('button');
            const stickyButtonLabel = stickyButtonContainer.querySelector('.add-to-cart-text__content > span:first-child');
            if (stickyButtonNode && stickyButtonLabel) {
                if (!this.container.classList.contains('hide')) {
                    // Out of stock
                    stickyButtonLabel.dataset.originalText = stickyButtonLabel.dataset.originalText || stickyButtonLabel.innerHTML;
                    stickyButtonLabel.innerHTML = this.button.textContent.trim();
                    stickyButtonNode.disabled = false;

                    // We need to bypass the native add to cart behavior on the sticky button
                    stickyButtonNode.dataset.notifyHijack = "true";

                    if (!stickyButtonNode.dataset.notifyListenerMounted) {
                        stickyButtonNode.addEventListener('click', (e) => {
                            if (stickyButtonNode.dataset.notifyHijack === "true") {
                                e.preventDefault();
                                e.stopPropagation();
                                this.onClick(e);
                            }
                        }, true);
                        stickyButtonNode.dataset.notifyListenerMounted = "true";
                    }
                } else {
                    // Back in stock — mirror pre-order.js: restore sticky label from saved markup
                    stickyButtonNode.dataset.notifyHijack = "false";
                    if (stickyButtonLabel.dataset.originalText) {
                        stickyButtonLabel.innerHTML = stickyButtonLabel.dataset.originalText;
                    }
                }
            }
        }

        // Update the variant ID in the notify button.
        const form = this.closest('form') || document.querySelector(`form[action="/cart/add"]`);
        if (form) {
            const idInput = form.querySelector('[name="id"]');
            if (idInput) {
                this.button.setAttribute('data-var-id', idInput.value);
            }
        }
    }

    onVariantChangeFallback(event) {
        // Basic fallback if MutationObserver fails
        setTimeout(() => this.updateVisibility(), 50);
    }

    onClick(evt) {
        evt.preventDefault();
        const variantId = this.button.getAttribute('data-var-id');
        const title = this.button.getAttribute('data-product-title') + ' - ' + this.button.getAttribute('data-variant-title');

        // Call the global showModal method provided by notify-me.js
        if (window.NotifyMe && window.NotifyMe.showModal) {
            window.NotifyMe.showModal(variantId, title);
        } else {
            console.error('NotifyMe global object not found. Ensure notify-me.js is loaded.');
        }
    }
}
customElements.define('notify-me-button-wrapper', NotifyMeButtonWrapper);
